import React from "react";
import WhatsAppButton from "./WhatsAppButton";
import { buildWA } from "../data/catalog";

const CTA = () => {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-[32px] p-10 sm:p-16 text-center">
          <div className="absolute inset-0 bg-gradient-to-br from-[#1a0a36] via-[#0d0717] to-[#0B0B0B]" />
          <div className="absolute inset-0 bg-grid opacity-50" />
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#7B2DFF]/30 blur-3xl pulse-glow" />
          <div className="absolute inset-0 ring-1 ring-inset ring-[#7B2DFF]/30 rounded-[32px]" />

          <div className="relative">
            <div className="text-xs tracking-[0.24em] uppercase text-[#9B5BFF] font-medium">
              ✦ Siap Melayani 24/7
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.02] max-w-3xl mx-auto">
              Butuh Produk Digital{" "}
              <span className="gradient-purple">Murah & Terpercaya?</span>
            </h2>
            <p className="mt-6 text-white/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
              DIGIFRIEND siap melayani kebutuhan digital Anda dengan cepat,
              aman, dan harga bersahabat. Klik tombol di bawah untuk langsung
              chat admin via WhatsApp.
            </p>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
              <WhatsAppButton
                testId="cta-final-wa"
                href={buildWA("Pesanan dari halaman utama DIGIFRIEND", "")}
                className="!py-4 !px-7 text-base"
              >
                Pesan via WhatsApp
              </WhatsAppButton>
              <a
                data-testid="cta-call-link"
                href="tel:+62882003976301"
                className="btn-ghost"
              >
                ☎ 0882-0039-76301
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
